import { useState } from 'react'
import { Text } from '@chakra-ui/react'
import { DataList, DataTable } from '@minetrace/ui'
import { brand, themeColors } from '../../theme'
import { syncService } from '../../api/services'
import type { FormalizedMinerRecord } from '../../api/services/sync.service'
import { usePagedRequest } from '../../hooks'
import SyncPageLayout from './SyncPageLayout'
import { useT } from '../../i18n'

export default function MinerosFormalesPage() {
  const colors = themeColors
  const { t } = useT()
  const [search, setSearch] = useState('')

  const formalized = usePagedRequest(syncService.getFormalizedMiners, {
    params: { search: search.trim() || undefined },
    pageSize: 25,
  })

  return (
    <SyncPageLayout
      title={t('sync.formalized.title')}
      subtitle={t('sync.formalized.subtitle')}
      syncType="FormalizedMiners"
      onRefresh={() => formalized.refresh()}
    >
      <DataList<FormalizedMinerRecord>
        searchValue={search}
        onSearchChange={setSearch}
        searchPlaceholder={t('sync.searchPlaceholder')}
        page={formalized.page}
        totalPages={formalized.totalPages}
        onPageChange={formalized.setPage}
        totalCount={formalized.totalCount}
        entityName="mineros formalizados"
        pageSize={formalized.pageSize}
        onPageSizeChange={formalized.setPageSize}
        brandColor={brand.primary}
        headers={[
          t('sync.formalized.headers.docNumber'),
          t('sync.formalized.headers.miner'),
          t('sync.formalized.headers.uniqueCode'),
          t('sync.formalized.headers.miningRight'),
          t('sync.formalized.headers.department'),
          t('sync.formalized.headers.province'),
          t('sync.formalized.headers.district'),
        ]}
        data={formalized.items}
        loading={formalized.isFetching}
        error={formalized.error}
        emptyMessage={t('sync.formalized.emptyMessage')}
        loadingMessage={t('sync.formalized.loadingMessage')}
        colors={colors}
        keyExtractor={(r) => r.id}
        renderRow={(r) => (
          <>
            <DataTable.Cell>
              <Text fontFamily="monospace" fontSize="sm" color={colors.text}>{r.documentNumber}</Text>
            </DataTable.Cell>
            <DataTable.Cell>
              <Text fontSize="sm" fontWeight="500" color={colors.text}>{r.minerName}</Text>
            </DataTable.Cell>
            <DataTable.Cell>
              <Text fontFamily="monospace" fontSize="sm" color={colors.text}>{r.uniqueCode}</Text>
            </DataTable.Cell>
            <DataTable.Cell>
              <Text fontSize="sm" color={colors.text}>{r.miningRightName}</Text>
            </DataTable.Cell>
            <DataTable.Cell>
              <Text fontSize="sm" color={colors.text}>{r.department}</Text>
            </DataTable.Cell>
            <DataTable.Cell>
              <Text fontSize="sm" color={colors.text}>{r.province}</Text>
            </DataTable.Cell>
            <DataTable.Cell>
              <Text fontSize="sm" color={colors.text}>{r.district}</Text>
            </DataTable.Cell>
          </>
        )}
      />
    </SyncPageLayout>
  )
}
